'use strict';

export { default as FileUploadFactory } from './fileUpload.factory';